import React, { useState, useEffect } from 'react';
import styles from './NewPropertyWizard.scss';
import { IPropertyWizardInput } from './NewPropertyWizard';
import Select from './Select';
import getUid from '../../utils/getUid';
import TextField from '../MaterialUi/TextField';
import Checkbox from '../MaterialUi/Checkbox';
import PropertyDescription from './PropertyDescription';
import NumberField from '../MaterialUi/NumberField';
// import { Box, Collapse, Grow, Zoom } from '@mui/material';
import Box from '@mui/material/Box';
import Grow from '@mui/material/Grow';
// import Checkbox from '../Checkbox';
import { TransitionGroup } from 'react-transition-group/dist/react-transition-group.js';
import { IEditProperty } from './EditProperty';

export type IInputsProps = IPropertyWizardInput

const Inputs: React.FC<React.PropsWithChildren<IInputsProps>> = ({ data = null, step = null, onChange = () => { } }) => {
    const firstInput = step.inputs.find((i) => !i.options);

    const [nextData, setNextData] = useState(data); // for showing internal state without rerendering complete parent component

    useEffect(() => {
        setNextData(data);
    }, [data]);

    const handleChange: IInputsProps['onChange'] = (name, value) => {
        setNextData({ ...nextData, [name]: value });
        onChange(name, value);
    };

    return (
        <div className={styles.inputs + (styles[step.name] ? ' ' + styles[step.name] : '')}>
            <TransitionGroup>
                {step.inputs.map((input) => {
                    const autoFocus = firstInput === input && location.hash.indexOf('step') > 0;
                    const value = data[input.name] as IInputItemProps['value'];
                    return (
                        <Grow key={input.name}>
                            <Box>
                                <InputItem key={input.name} data={data} onChange={handleChange} input={input} value={value} autoFocus={autoFocus} />
                            </Box>
                        </Grow>
                    );
                })}
            </TransitionGroup>
        </div>
    );
};

interface IInputItemProps {
    value: string | number | boolean;
    input: IInputsProps['step']['inputs'][0];
    onChange: IInputsProps['onChange'];
    data: IInputsProps['data'];
    autoFocus: boolean;
}

const InputItem: React.FC<React.PropsWithChildren<IInputItemProps>> = ({ value, input, onChange, data, autoFocus }) => {
    const [labelUid] = useState(() => getUid('inputs'));
    const [validHint, setValidHint] = useState<string>('');

    const isVisible = (!input.showOn || data[input.showOn]) && (!input.hideOn || !data[input.hideOn]);

    if (isVisible && (value === null || value === undefined) && input.defaultValue) {
        onChange(input.name, input.defaultValue);
    }

    const handleChange = (name: keyof IEditProperty, value: number) => {
        onChange(name, value);
        if (validHint && input.isValid(Number(value))) {
            setValidHint('');
        }
    };

    const handleBlur = () => {
        if (value && input.isValid && !input.isValid(Number(value)) && input.validHint) {
            setValidHint(input.validHint);
        } else {
            setValidHint('');
        }
    };

    const isSelect = !!input.options;

    return isSelect ? (
        isVisible ? (
            <Select key={input.name} step={input} data={data} onChange={onChange} />
        ) : null
    ) : input.type === 'boolean' ? (
        isVisible ? (
            <Checkbox
                key={input.name}
                onChange={(ev) => {
                    onChange(input.name, ev.target.checked);
                }}
                // value="true"
                // checked={!!data[input.name]}
                value={!!data[input.name]}
                name={input.name}
                label={input.title}
            />
        ) : null
    ) : input.type === 'html' ? (
        isVisible ? (
            <PropertyDescription key={input.name} step={input} data={data} onChange={onChange} />
        ) : null
    ) : input.type === 'text' ? (
        isVisible ? (
            <TextField
                key={input.name}
                name={input.name}
                value={value || ''}
                onChange={(ev) => {
                    onChange(ev.target.name as IInputItemProps['input']['name'], ev.target.value);
                }}
                label={input.title}
            // required={true}
            ></TextField>
        ) : null
    ) : (
        isVisible && (
            <NumberField
                key={input.name}
                label={input.title}
                id={labelUid + input.name}
                onChange={handleChange}
                name={input.name}
                value={value as string | number}
                thousandSeparator={'.'}
                decimalSeparator={','}
                disabled={false}
                suffix={input.unit ? ` ${input.unit}` : null}
                allowEmptyFormatting
                autoFocus={autoFocus}
                error={validHint !== ''}
                helperText={validHint}
                onBlur={handleBlur}
                fixedDecimalScale={input.unit === '€' && value && parseInt(value as string) !== parseFloat(value as string)}
                decimalScale={input.decimalScale ? input.decimalScale : input.unit === '€' ? 2 : 0}
            ></NumberField>
        )
    );
};

export default Inputs;
